import React from 'react';
import { PageHero } from '../components/PageHero';
import { CTABand } from '../components/CTABand';
import { SectionLabel } from '../components/SectionLabel';
import { StatusTag } from '../components/StatusTag';
import { MissionVision } from '../components/MissionVision';
import { Footprint } from '../components/Footprint';
import { IMAGES, LEADERSHIP, PRINCIPLES, PRODUCTS } from '../data/site';
export function About() {
  return <>
      <PageHero eyebrow="About" title="We build software for the parts of Africa's economy that run on memory." lede="Keystone Technologies is a technology company. We are bold and courageous enough to tackle the biggest problems facing our continent, and we build the technology to solve them." data-id="element-196" data-mp="328u9il4ta61z" />

      <section className="border-b border-ink-100" data-id="element-197" data-mp="2xb0yneskcnvd">
        <img src={IMAGES.operations} alt="Keystone Technologies product and engineering workspace" className="h-[20rem] w-full object-cover lg:h-[28rem]" data-id="element-198" data-mp="1gu6k4sxdy7mm" />
      </section>

      <section className="border-b border-ink-100" data-id="element-199" data-mp="1uibmiiupjfpd">
        <div className="mx-auto grid max-w-container gap-10 px-6 py-16 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-10 lg:py-24" data-id="element-200" data-mp="1piyt1f9bzadt">
          <div data-id="element-201" data-mp="23jjcmdn2la8d">
            <SectionLabel data-id="element-202" data-mp="23k1dxoolaen5">The company</SectionLabel>
            <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-ink-900 lg:text-4xl" data-id="element-203" data-mp="1yjn7gb2mzcr8">
              Ideas that change the world, built where they are needed
            </h2>
          </div>
          <div className="max-w-2xl" data-id="element-204" data-mp="28icmzx728l4b">
            <p className="text-lg leading-relaxed text-ink-700" data-id="element-205" data-mp="28hb1szwbyi8v">
              We started from a simple observation: across African markets, the
              constraint is rarely effort or capital. It is information. A
              landlord loses a month of rent because a reminder was never sent. A
              family loses land because a title was altered in a paper file. A
              SACCO cannot lend because its repayment history lives in a ledger
              book nobody can audit.
            </p>
            <p className="mt-5 text-base leading-relaxed text-ink-600" data-id="element-206" data-mp="1osjumwagx3aj">
              Each of our products attacks one of those failures directly.
              PropFlow is live and managing real portfolios today. LandChain and
              SACCO Suite are in development for 2026. We build for African
              conditions first — mobile money, WhatsApp, intermittent
              connectivity — and design each system to work across markets rather
              than for one city.
            </p>
          </div>
        </div>
      </section>

      <MissionVision data-id="element-207" data-mp="2glkewotmyp2u" />

      <Footprint data-id="element-208" data-mp="2gmc1591cfagg" />

      <section className="border-b border-ink-100 bg-ink-950" data-id="element-209" data-mp="2gjpurcq6v0zt">
        <div className="mx-auto max-w-container px-6 py-16 lg:px-10 lg:py-24" data-id="element-210" data-mp="2ljm0phig52i0">
          <SectionLabel tone="dark" data-id="element-211" data-mp="m8kw6mtylerc">Principles</SectionLabel>
          <h2 className="mt-6 max-w-2xl text-3xl font-semibold leading-tight tracking-tight text-white lg:text-4xl" data-id="element-212" data-mp="ma5qcbcd2voo">
            How we decide what to build
          </h2>

          <ul className="mt-12 grid gap-10 md:grid-cols-3" data-id="element-213" data-mp="joxyuzpjoq9i">
            {PRINCIPLES.map(principle => <li key={principle.title} className="border-t border-ink-700 pt-6" data-id="element-214" data-mp="evbxw4squatj">
                <h3 className="text-xl font-semibold tracking-tight text-white" data-id="element-215" data-mp="9y3czwg7nsol">
                  {principle.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-400" data-id="element-216" data-mp="4wmg0c0ukqda">
                  {principle.text}
                </p>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="border-b border-ink-100" data-id="element-217" data-mp="so1ic4smj7oj">
        <div className="mx-auto max-w-container px-6 py-16 lg:px-10 lg:py-24" data-id="element-218" data-mp="smqjmje1cq4a">
          <SectionLabel data-id="element-219" data-mp="on7ypnm7sf1g">Roadmap</SectionLabel>
          <h2 className="mt-6 max-w-2xl text-3xl font-semibold leading-tight tracking-tight text-ink-900 lg:text-4xl" data-id="element-220" data-mp="ooiylccjh2na">
            Where each product stands
          </h2>

          <ol className="mt-10 divide-y divide-ink-100 border-y border-ink-200" data-id="element-221" data-mp="39b4124pmime8">
            {PRODUCTS.map(product => <li key={product.slug} className="grid gap-3 py-6 lg:grid-cols-[14rem_1fr_14rem] lg:items-baseline lg:gap-8" data-id="element-222" data-mp="111w8dy33cuy4">
                <h3 className="text-xl font-semibold tracking-tight text-ink-900" data-id="element-223" data-mp="r74d50wzek6i">
                  {product.name}
                </h3>
                <p className="max-w-xl text-sm leading-relaxed text-ink-600" data-id="element-224" data-mp="w2jjz8wknftf">
                  {product.category} — {product.lede}
                </p>
                <div className="lg:text-right" data-id="element-225" data-mp="1os8ohw8hpxzs">
                  <StatusTag status={product.status} timing={product.timing} data-id="element-226" data-mp="1atsiy8md6dj8" />
                </div>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="border-b border-ink-100 bg-ink-50" data-id="element-227" data-mp="1etkkw2h95lfm">
        <div className="mx-auto max-w-container px-6 py-16 lg:px-10 lg:py-20" data-id="element-228" data-mp="3viydiy9y2yuq">
          <SectionLabel data-id="element-229" data-mp="3gqf8trptr40">Team</SectionLabel>
          <h2 className="mt-6 max-w-2xl text-2xl font-semibold leading-tight tracking-tight text-ink-900 lg:text-3xl" data-id="element-230" data-mp="3hs1zvi3g21k">
            A small team close to the operators we build for
          </h2>

          <ul className="mt-10 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-231" data-mp="3n2h8lcdjmdmk">
            {LEADERSHIP.map(person => <li key={person.name} className="flex h-full flex-col" data-id="element-232" data-mp="5sj5iqb42cvs">
                <span className="block h-1 w-10 bg-bronze-500" aria-hidden="true" data-id="element-233" data-mp="wby0t32gtbq" />
                <h3 className="mt-5 text-lg font-semibold tracking-tight text-ink-900" data-id="element-234" data-mp="39cdtr6gztm75">
                  {person.name}
                </h3>
                <p className="mt-1 text-sm text-bronze-600" data-id="element-235" data-mp="34aoetfqngods">{person.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-ink-600" data-id="element-236" data-mp="3j2qbkqxfb19l">
                  {person.bio}
                </p>
              </li>)}
          </ul>
        </div>
      </section>

      <CTABand title="Building in property, land, or community finance?" text="Whether you want to use a product, pilot one, or partner with us on a market, we would like to hear from you." primaryLabel="Get in touch" secondaryLabel="See products" secondaryTo="/products" data-id="element-237" data-mp="2qj9xddce4v8u" />
    </>;
}